import _ from 'lodash'

export default {
  setEmployers(state, value) {
    state.employers = value
  },
  concatEmployers(state, value) {
    state.employers = state.employers.concat(value)
  },
  setEmployerFilters(state, filters) {
    state.employerFilters = filters
  },
  setEmployer(state, value) {
    state.employer = value
  },
  setEmployersCounter(state, value) {
    state.employersCounter = value
  },
  setEmployerOriginal(state, value) {
    state.employerOriginal = value
  },
  setEmployerServicesAndCategory(state, employer) {
    // @ToDo: check fix
    if (employer) {
      // Create 'service' object
      employer.serviceIDs = {}
      for (let i = 0; i < employer.services.length; i++) {
        const service = employer.services[i]
        employer.serviceIDs[service.id] = {
          active: true,
          duration: service.pivot.duration,
        }
      }
    }
  },
  setNullMasters(state) {
    state.employers = []
  },
  setEmployerErrors(state, serviceErrors) {
    state.employerErrors = serviceErrors
  },
  setEmployerField(state, obj) {
    if (obj.value === '') obj.value = null
    state.employer = { ...state.employer, [obj.key]: obj.value }
  },
  setEmployerInfo(state, obj) {
    const fields = state.employer.info.fields

    if (!fields || !fields.length) {
      fields.push(obj)
      return
    }

    // check every field to exists
    const fieldExists = _.map(fields, field => {
      if (field.type == obj.type && field.key == obj.key) return true
      return false
    })

    // get every result
    const checkedFields = _.every(fieldExists, item => {
      return item == false
    })

    if (checkedFields) {
      fields.push(obj)
      return
    }

    _.forEach(fields, field => {
      if (field.type == obj.type && field.key == obj.key) field.value = obj.value
    })
  },
  setNullEmployerInfo(state) {
    state.employer.info.fields = []
  },
  setEmployerErrorsField(state, obj) {
    if (state.employerErrors) {
      state.employerErrors[obj.key] = obj.value
    }
  },
  setEmployerPermissions(state, permissions) {
    state.employerPermissions = permissions
  },
  setEmployerShedule(state, shedule) {
    state.employerShedule = shedule
  },
  setEmployerScheduleType(state, scheduleType) {
    state.employerScheduleType = []
    for (const key in scheduleType.schedule_type) {
      state.employerScheduleType.push({
        id: parseInt(key),
        title: scheduleType.schedule_type[key],
      })
    }
  },
  setHrEmployers(state, value) {
    state.hrEmployers = value
  },
  selectEmployerPermission(state, permission) {
    for (let i = 0; i < state.employerPermissions.length; i++) {
      const currentPermission = state.employerPermissions[i]
      if (currentPermission === permission.model) {
        delete state.employerPermissions[i]
        return
      }
    }
    state.employerPermissions.push(permission.model)
  },
  changeEmployer(state, payload) {
    for (let i = 0; i < state.employers.length; i++) {
      if (state.employers[i].id === payload.key) {
        state.employers.splice(i, 1, payload.value)
        break
      }
    }
  },
  unshiftEmployers(state, employer) {
    state.employers.unshift(employer)
  },
  deleteEmployer(state, id) {
    for (let i = 0; i < state.employers.length; i++) {
      if (state.employers[i].id === id) {
        state.employers.splice(i, 1)
        break
      }
    }
  },
  setEmployerServices(state, services) {
    state.employerServices = services
  },
  setEmployersBrands(state, brands) {
    state.employersBrands = brands
  },

  setServiceEmployer(state, employers) {
    state.serviceEmployer = employers
  },
  setEmployerStatuses(state, arr) {
    state.employerStatuses = arr
  },
  setEmployerStates(state, arr) {
    state.employerStates = arr
  },
  setHuntingResources(state, huntingResources) {
    state.huntingResources = huntingResources
  },
  setEmployersLoadedAtLeastOnce(state, payload) {
    state.employersLoadedAtLeastOnce = payload
  },
  setServiceEmployers(state, employers) {
    state.serviceEmployers = employers
  },
  setLoadingServiceEmployers(state, value) {
    state.isLoadingServiceEmployers = value
  },
  updateServiceEmployers(state, employers) {
    state.serviceEmployers = state.serviceEmployers.concat(employers)
  },
  setServiceWorkerFilterValue(state, value) {
    state.serviceWorkerFilterValue = value
  },
  setDocumentTypes(state, payload) {
    state.documentTypes = payload
  },
  setEmployerDocument(state, payload) {
    state.employerDocument = payload
  },
  setEmployerDocumentField(state, { field, value }) {
    state.employerDocument[field] = value
  },
}
